import {useContext} from 'react';
import {AsyncFileUploaderContext} from '@src/components/AsyncFileUploader/AsyncFileUploaderContext';

export default function useUploader() {
    return useContext(AsyncFileUploaderContext);
}
